import React from "react";
import { useIsMobile } from "../hooks/useIsMobile";
import { Logo } from "./Logo";

export function MobileOnlyGate({ children }: { children: React.ReactNode }) {
  const isMobile = useIsMobile();

  if (isMobile) return <>{children}</>;

  return (
    <div className="fixed inset-0 bg-bg flex flex-col items-center justify-center px-8 text-center">
      <Logo size="lg" />

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-16 h-16 text-muted mt-10"
      >
        <rect x={7} y={2} width={10} height={20} rx={2} />
        <line x1={12} y1={18} x2={12} y2={18.01} />
      </svg>

      <h1 className="text-2xl font-semibold text-foreground mt-6">
        Mobile Only
      </h1>
      <p className="text-muted mt-2 max-w-sm">
        This app is designed for mobile devices. Please open it on your phone.
      </p>

      <a
        href="https://app.cradleos.com"
        className="mt-8 inline-block rounded-lg bg-primary px-5 py-2.5 text-sm font-medium text-white hover:opacity-90 transition-opacity"
      >
        Visit the desktop experience →
      </a>
    </div>
  );
}
